import { createContext, useContext } from 'react';

export interface OlAuthUser {
  name: string;
  email?: string;
  sub?: string;
  roles: string[];
  /**
   * True when a `realm_access` claim was actually FOUND (access token or profile). Keycloak's
   * default puts realm roles in the ACCESS token only — when no source carries the claim, roles
   * are UNKNOWN (not "none") and role-based visual gates must fail OPEN (the API enforces).
   */
  rolesKnown: boolean;
}

export type OlAuthStatus = 'loading' | 'authenticated' | 'unauthenticated' | 'error';

export interface OlAuth {
  status: OlAuthStatus;
  isAuthenticated: boolean;
  user: OlAuthUser | null;
  error?: string;
  /** Begin sign-in (OIDC redirect). No-op in mock mode. */
  login: () => void;
  /** Sign out (OIDC end-session or local removal). */
  logout: () => void;
  /** True when running the dev-standalone mock session. */
  mock: boolean;
}

export const OlAuthContext = createContext<OlAuth | null>(null);

export function useAuth(): OlAuth {
  const ctx = useContext(OlAuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within <OneLatticeAuthProvider>.');
  }
  return ctx;
}
